import { ChartColumnIncreasing, Radio, type LucideIcon } from "lucide-react";

export type RefreshMode = "live" | "report";

/** The icons of the Live Monitoring and Measurement spaces, so a dashboard's kind reads like them. */
export const LIVE_ICON: LucideIcon = Radio;
export const REPORT_ICON: LucideIcon = ChartColumnIncreasing;

/**
 * The two ways a dashboard keeps its data current, worded once for every place
 * that shows them: the settings window, the library filters and the tables.
 */
export const REFRESH_MODE_OPTIONS: readonly {
  value: RefreshMode;
  label: string;
  description: string;
  icon: LucideIcon;
}[] = [
  { value: "report", label: "Report", description: "Results and analysis", icon: REPORT_ICON },
  { value: "live", label: "Live", description: "Real-time monitoring", icon: LIVE_ICON },
];
